const onboarding = {
  businessLogic: {
    title: 'Lógica de negocios',

    areasOfOpertaion: {
      title: 'Zonas de operación',
      subTitle: 'Muéstrenos dónde opera. Elija una ciudad, estado o solo un barrio, depende de usted.',
      hideLightZones: 'Resaltar zonas',
    },

    operationPreferences: {
      title: 'Preferencias de operación',
      subTitle: 'Ayúdanos a conocerte mejor.',

      form: {
        sections: {
          operationPrefernces: {
            header: '¿Cuáles son sus preferencias de operación?',
            operationPreferncesOptions: {
              singleRides: 'Viajes individuales',
              sharedRides: 'Viajes compartidos',
            },
          },

          routingSettings: {
            header: 'Configuración de ruteo',
            info: 'Doración Máxima: duración máxima de un viaje. Parada Máx .: paradas máximas en un viaje. Relación: 1,5 significa que la duración de una persona sentada en el vehículo no excede el 150% del tiempo que habría estado conduciendo a solas. Máx. De pasajeros: cantidad máxima de asientos por viaje.',

            fields: {
              maxDuration: 'Duración máxima',
              paxAtOnce: 'Pax de una vez',
              maxStops: 'Paradas Máx.',
              jobsAtOnes: 'Trabajos de una vez',
              maxPassengers: 'Máx. Pasajeros',
              rate: 'Tasa',
              pickAll: 'Seleccionar todos',
            },
          },

          pickSettings: {
            header: 'Configuración de selección',
            info: 'Doración Máxima: duración máxima de un viaje. Parada Máx .: paradas máximas en un viaje. Relación: 1,5 significa que la duración de una persona sentada en el vehículo no excede el 150% del tiempo que habría estado conduciendo a solas. Máx. De pasajeros: cantidad máxima de asientos por viaje.',

            fields: {
              ambulatory: 'Ambulante (Mínimo)',
              wheelchair: 'Silla de ruedas (Mínimo)',
              maxEarly: 'Máx. Temprana (mín.)',
              maxLate: 'Máx. Tarde (mín.)',
            },
          },

          dropSettings: {
            header: 'Configuración de Deja',
            info: 'Doración Máxima: duración máxima de un viaje. Parada Máx .: paradas máximas en un viaje. Relación: 1,5 significa que la duración de una persona sentada en el vehículo no excede el 150% del tiempo que habría estado conduciendo a solas. Máx. De pasajeros: cantidad máxima de asientos por viaje.',

            fields: {
              ambulatory: 'Ambulante (Mínimo)',
              wheelchair: 'Silla de ruedas (Mínimo)',
              maxEarly: 'Máx. Temprana (mín.)',
              maxLate: 'Máx. Tarde (mín.)',
            },
          },
        },
      },
    },

    fleetDefenition: {
      title: 'Defeninición de flota',
      subTitle: 'Ahora, hablemos de flota. ¡Casi listo!',

      form: {
        sections: {
          assignmentPreferences: {
            header: '¿Cuáles son sus preferencias generales de asignación de conductores?',
            fields: {
              defaultCarLocation: 'Ubicación predeterminada del coche (dirección)',
              maxDuration: 'Duración máxima del turno (minutos)',
            },
            assignmenOptions: {
              leastVehicles: 'Menos <br/> cantidad de vehículos',
              balacedVehicles: 'Ruteo Equilibrado',
            },
          },

          vehiclesAndDrivers: {
            header: '¿Cuántos vehículos y conductores hay?',
            vehicles: 'Vehículos',
            drivers: 'Conductores',

            quickEntry: {
              header: 'ENTRADA RÁPIDA',
              fields: {
                numberOfVehicles: 'Cantidad de vehículos',
                wheelChairVehicles: 'Vehículos para sillas de ruedas',
                numberOfDrivers: 'Cantidad de conductores',
                wheelChairDrivers: 'Conductores de silla de ruedas',
              },
            },

            files: {
              header: 'Por favor, especifique sus ubicaciones de entrada y salida',
              explanation: 'Explicación de lo que significa exactamente. Explicación y más explicación y eso podría ser suficiente.',
              example: 'Asegúrese de tratar todos los atributos correctamente. ',
              exampleFileText: 'para obtener el mejor resultado, no dude en utilizar nuestro',
              exampleFile: 'archivo de ejemplo',
              trySampleText: '¿No hay datos? ',
              trySampleBtn: 'Intente una muestra.',
            },

            uploadData: {
              header: 'CARGAR DATOS',
              firstLine: 'Asegúrese de incluir todos los atributos. Para obtener los mejores resultados, siéntete',
              secondLine: {
                firsTpart: 'libre de usar nuestro',
                vehicle: 'Archivo de ejemplo de vehículos',
                and: 'y',
                drivers: 'Archivo de ejemplo de conductores',
              },
            },
          },
        },
      },
    },

    scheduleAutomation: {
      title: 'Automatización de programación',
      subTitle: 'Ayúdanos a conocerte mejor.',
    },

    additionalFeatures: {
      title: 'Caracteristicas adicionales',
      subTitle: 'Mientras más sepamos, mejor servicio seremos capaces de proporcionar.',

      form: {
        file: {
          header: 'Por favor, especifique sus ubicaciones de entrada y salida',
          explanation: 'Explicación de lo que significa exactamente. Explicación y más explicación y eso podría ser suficiente.',
          example: 'Asegúrese de tratar todos los atributos correctamente. ',
          exampleFileText: 'para obtener el mejor resultado, no dude en utilizar nuestro',
          exampleFile: 'archivo de ejemplo',
          trySampleText: '¿No hay datos? ',
          trySampleBtn: ' Intente una muestra.',
        },

        willCall: {
          header: '¿Desea habilitar la opción "Pediría"?',
          info: 'Doración Máxima: duración máxima de un viaje. Parada Máx .: paradas máximas en un viaje. Relación: 1,5 significa que la duración de una persona sentada en el vehículo no excede el 150% del tiempo que habría estado conduciendo a solas. Máx. De pasajeros: cantidad máxima de asientos por viaje.',
          on: 'En',
          off: 'Desactivado',
          time: 'Tiempo',
          attribute: 'Atributo',
          explanation: 'Asegúrese de incluir la propiedad de atributo en sus archivos de demanda',
        },
      },
    },
  },

  assets: {
    title: 'Activos',
    fleetDefinition: {
      title: 'Definición de flota',
      subTitle: 'Ahora, hablemos de flota. ¡Casi listo!',
    },
  },

  demand: {
    title: 'Demanda',

    dataUpload: {
      title: 'Carga de datos',
      subTitle: '¡Aliménteme con la Demanda y estamos listos para comenzar!',

      form: {
        file: {
          explanation: 'Asegúrese de tratar todos los atributos correctamente. Para obtener el mejor resultado, siéntelo ',
          example: 'libre de usar nuestro',
          exampleFile: 'archivo de ejemplo',
          trySampleText: '¿No hay datos?',
          trySampleBtn: 'Intente una muestra.',
        },
      },
    },
  },

  save: 'Siguiente',

  kpi: {
    title: 'PASOS completados',
    wellDone: '¡Muy bien hecho!',
    labels: {
      onboardingKpiCompleted: 'Completado',
    },
  },

  submit: {
    text: '¡Y eso es todo! estamos listos. si está contento con sus respuestas y no desea cambiar nada, siga adelante y cree escenario personalizado.',
    create: 'Crear escenario',
  },
};

export default onboarding;
